"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeEventListenerForContainer = exports.addEventListenerForContainer = void 0;

var _throttle = _interopRequireDefault(require("lodash/throttle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Script to make the main container scrollable during drag-drop
// CONSTANTS
var PX_DIFF = 4; // GLOBAL VARIABLES

var scrollIncrement = 0;
var isScrolling = false;
var containerElement = null; // Scroll up in the container.

var goUp = function goUp() {
  scrollIncrement -= PX_DIFF;
  containerElement.scrollTop = scrollIncrement;

  if (isScrolling && scrollIncrement >= 0) {
    window.requestAnimationFrame(goUp);
  }
}; // Scroll down in the container.


var goDown = function goDown() {
  scrollIncrement += PX_DIFF;
  containerElement.scrollTop = scrollIncrement;

  if (isScrolling && scrollIncrement <= containerElement.scrollHeight) {
    window.requestAnimationFrame(goDown);
  }
};

var onDragOver = function onDragOver(event) {
  var clientRect = containerElement.getBoundingClientRect();
  var offset = (clientRect.bottom - clientRect.top) / 4;
  var isMouseOnTop = scrollIncrement >= 0 && event.clientY > clientRect.top && event.clientY < clientRect.top + offset;
  var isMouseOnBottom = scrollIncrement <= containerElement.scrollHeight && event.clientY > window.innerHeight - offset && event.clientY <= window.innerHeight;

  if (!isScrolling && (isMouseOnTop || isMouseOnBottom)) {
    isScrolling = true;
    scrollIncrement = containerElement.scrollTop;

    if (isMouseOnTop) {
      window.requestAnimationFrame(goUp);
    } else {
      window.requestAnimationFrame(goDown);
    }
  } else if (!isMouseOnTop && !isMouseOnBottom) {
    isScrolling = false;
  }
}; // The "throttle" method prevents executing the same function multiple times.


var throttleOnDragOver = (0, _throttle["default"])(onDragOver, 300); // Call on beginDrag

var addEventListenerForContainer = function addEventListenerForContainer(containerId) {
  containerElement = document.getElementById(containerId);
  containerElement.addEventListener('dragover', throttleOnDragOver);
}; // Call on endDrag


exports.addEventListenerForContainer = addEventListenerForContainer;

var removeEventListenerForContainer = function removeEventListenerForContainer() {
  containerElement.removeEventListener('dragover', throttleOnDragOver);
  isScrolling = false;
};

exports.removeEventListenerForContainer = removeEventListenerForContainer;